import { initialState } from "../initialState";


const settings = (state = initialState, action) => {
  let newTabsList = [];

  const currentTab = (tab, tabList) => tabList.findIndex((curTab) => curTab === tab) > -1
    ? ({
      id: tabList.findIndex((curTab) => curTab === tab),
      name: tab
    })
    : ({
      id: tabList.length - 1,
      name: tabList[tabList.length - 1]
    });


  switch (action.type) {
    case "UPDATE_SETTINGS":
      return {
        ...state,
        ...action.payload
          .map(([key, value]) => ({ [key]: value }))
          .reduce((target, current) => ({ ...target, ...current }), {})
      };

    case "DELETE_TAB":
      newTabsList = [
        ...state.tabs.filter((tab) => {
          return tab !== action.id;
        })
      ];

      return {
        ...state,
        tabs: newTabsList,
        tabIndex: currentTab(state.tabIndex.name, newTabsList)
      };

    case "ADD_TAB":
      newTabsList = [...state.tabs, action.id].sort((a, b) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });

      return {
        ...state,
        tabs: newTabsList,
        tabIndex: {
          id: newTabsList.findIndex((tab) => tab === action.id),
          name: action.id
        }
      };

    case "CHANGE_TAB":
      return {
        ...state,
        tabIndex: action.payload
      };

    default:
      return state;
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/store/reducers/settings.js